import Breadcrumb from '../Component/Breadcrumb'
const RulesReg = () => {
    return (
        <>
            <Breadcrumb breadtitle="Rules & Regulation" breadmid="Academic" breadend="Rules & Regulation" />
            <div className="innerpage">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className='maintitle'>Rules & Regulation</h2>
                            <ul className='list-view'>
            <li>Once the students enter the school campus they are not allowed to go out of the gate for any reason
              without the permission of the principal.</li>
            <li>Students are expected to behave respectfully in the school as well as outside the school.</li>
            <li>It is the duty of students to keep the school premises clean and tidy. Sctibbling on books, desks, wall
              etc. is strictly forbidden. Damage caused to the school properly by the pupils must be compensated by them
              at the discretion of the Principal.</li>
            <li>Students themselves are responsible for their own books, note-books, pen, tiffin, cycles, etc.</li>
            <li>Students should not exchange their books or any other study material with other students, neither
              borrowing nor lending them. No money or valuable things should be brought to the school.</li>
            <li>No books, periodicals or newspapers, mobiles, cameras and other gadgets should be brought to the school
              without the sanction of the Principal.</li>
            <li>During assembly and recess, no pupil will remain in the class rooms neither should they enter other
              classes.</li>
            <li>Students should not open the bags of other students for any reason.</li>
            <li>At the end of each period they will silently wait for the next teacher. They should not get up and move
              in the class, neither should they touch the black board or any other articles in the classes unless they
              are appointed by the teacher to do so.</li>
            <li>No student is allowed to leave the class room without the permission of the Teacher.</li>
            <li>In the absence of the teacher, the class leader will be responsible for the order and discipline of the
              class.</li>
            <li>At the end of the morning and noon sessions, the teacher should see that all lights and fans are
              switched off.</li>
            <li>Private tuitions are not encouraged. Pupils should be attentive in the class while lessons are taught.
            </li>
            <li>Money collections are absolutely forbidden without the permission of the Principal. No student will give
              any individual gifts or presents to any Staff Member.</li>
            <li>Students should be in the school campus 10 minutes before the first bell.</li>
            <li>Parents are expected to co-operate in the work of the school by enforcing regularity, punctuality and
              discipline, and by taking daily interest in their children's progress. They should check the dairy for any
              remark and note the homework, set.</li>
            <li>Students should be provided with necessary tiffin from home. They are forbidden to bring money to the
              school for any purpose. They wwill not buy any eatables from hawkers. Parents should train their children
              to saving habits.</li>
            <li>Students are not allowed to bring Mobile Phones or any Electronic Device in the school campus. If they
              are found in posession of any of the above, it will be confiscated.</li>
            <li>Students should refrain from writing/position/commenting negatively against fellow-students, staff
              members or the school management on Social Media. Any misuse of the social media to deframe the school
              will result in instant expulsion from the school.</li>
          </ul>
                        </div>
                    </div>
                </div> 
            </div>
        </>
    )
}
export default RulesReg